export default __webpack_public_path__ + "static/media/disconnect.d74e0a26.svg";